document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-beovea-cart-drawer]');
  const overlay = document.querySelector('[data-beovea-cart-overlay]');
  const openBtns = document.querySelectorAll('[data-beovea-cart-open]');
  const closeBtn = document.querySelector('[data-beovea-cart-close]');
  const itemsWrap = document.querySelector('[data-beovea-cart-items]');
  const emptyWrap = document.querySelector('[data-beovea-cart-empty]');
  const footer = document.querySelector('[data-beovea-cart-footer]');
  const countEl = document.querySelector('[data-beovea-cart-count]');
  const subtotalEl = document.querySelector('[data-beovea-cart-subtotal]');
  const shippingWrap = document.querySelector('.beovea-cart-drawer__shipping');
  const shippingTextEl = document.querySelector('[data-beovea-cart-shipping-text]');
  const progressEl = document.querySelector('[data-beovea-cart-progress]');
  const thresholdLabelEl = document.querySelector('[data-beovea-cart-threshold-label]');
  const recommendWrap = document.querySelector('[data-beovea-cart-recommend]');
  const recommendList = document.querySelector('[data-beovea-cart-recommend-list]');
  const recommendPool = document.querySelector('[data-beovea-cart-recommend-pool]');

  if (!drawer || !overlay) return;

  const freeShippingThreshold = parseInt(drawer.dataset.freeShippingThreshold || '1500', 10);

  const HARDCODED_TITLE_MAP = {
    'heated-eyelash-curler-305': 'Heated Eyelash Curler',
    'soft-silicone-body-scrubber-108': 'AuraCleanse™ Silicone Body Scrubber',
    'cryo-massage-roller-411': 'Gold Cryo Sculpting Spoon',
    'face-eye-cryosculptor-413': 'AuraFlow™ Sculpting Gua Sha',
    'hair-identifier-spray-for-face-shaving-dermaplaning-prep-spray-for-peach-fuzz-glowing-skin': 'Hair Identifier Spray',
    'sonic-dermaplaning-tool-for-face-peach-fuzz-dead-skin-remover': 'Sonic Dermaplaning Tool'
  };

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function formatMoneyWithUSD(cents) {
    return `${formatMoney(cents)} USD`;
  }

  function shuffleArray(arr) {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }

  function getDisplayTitle(handle, fallbackTitle) {
    if (handle && HARDCODED_TITLE_MAP[handle]) {
      return HARDCODED_TITLE_MAP[handle];
    }
    return fallbackTitle;
  }

  function getVariantText(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }

    if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
      const values = item.options_with_values
        .map((opt) => opt && opt.value ? String(opt.value).trim() : '')
        .filter(Boolean);

      if (values.length) return values.join(', ');
    }

    if (Array.isArray(item.options) && item.options.length) {
      const values = item.options
        .map((value) => value ? String(value).trim() : '')
        .filter((value) => value && value !== 'Default Title');

      if (values.length) return values.join(', ');
    }

    return '';
  }

  function renderRandomRecommendations(cart) {
    if (!recommendList || !recommendPool) return;

    const cartHandles = new Set(
      Array.isArray(cart?.items)
        ? cart.items.map((item) => item.handle).filter(Boolean)
        : []
    );

    const poolItems = Array.from(recommendPool.children);
    const uniqueMap = new Map();

    poolItems.forEach((node) => {
      const handle = node.getAttribute('data-rec-handle') || Math.random().toString();
      if (cartHandles.has(handle)) return;
      if (!uniqueMap.has(handle)) {
        uniqueMap.set(handle, node);
      }
    });

    const uniqueItems = Array.from(uniqueMap.values());
    const selected = shuffleArray(uniqueItems).slice(0, 4);

    recommendList.innerHTML = '';

    if (!selected.length) {
      recommendWrap?.classList.add('hidden');
      return;
    }

    recommendWrap?.classList.remove('hidden');

    selected.forEach((card) => {
      recommendList.appendChild(card.cloneNode(true));
    });
  }

  function scrollCartToTop() {
    requestAnimationFrame(() => {
      drawer.scrollTop = 0;
      const cartBody = drawer.querySelector('.beovea-cart-drawer__body');
      if (cartBody) cartBody.scrollTop = 0;
    });
  }

  function openDrawer() {
    drawer.classList.add('active');
    overlay.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('beovea-cart-open');
    document.documentElement.classList.add('beovea-cart-open');
    scrollCartToTop();
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('beovea-cart-open');
    document.documentElement.classList.remove('beovea-cart-open');
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  function renderShipping(cart) {
    const subtotal = cart.total_price || 0;
    const remain = Math.max(freeShippingThreshold - subtotal, 0);
    const progress = Math.min((subtotal / freeShippingThreshold) * 100, 100);
    const isEmpty = subtotal <= 0;
    const isEarned = subtotal >= freeShippingThreshold;

    progressEl.style.width = `${progress}%`;
    thresholdLabelEl.textContent = formatMoney(freeShippingThreshold);

    if (shippingWrap) {
      shippingWrap.classList.remove('is-empty', 'is-progress', 'is-earned');

      if (isEmpty) {
        shippingWrap.classList.add('is-empty');
      } else if (isEarned) {
        shippingWrap.classList.add('is-earned');
      } else {
        shippingWrap.classList.add('is-progress');
      }
    }

    if (isEarned) {
      shippingTextEl.innerHTML = `You've earned <strong>Free Shipping</strong>.`;
    } else {
      shippingTextEl.innerHTML = `Unlock <strong>free shipping</strong> by adding <strong>${formatMoney(remain)}</strong> more.`;
    }
  }

  function renderItems(cart) {
    countEl.textContent = cart.item_count || 0;
    subtotalEl.textContent = formatMoneyWithUSD(cart.total_price || 0);
    renderShipping(cart);

    const checkoutBtn = footer ? footer.querySelector('.beovea-cart-drawer__checkout') : null;

    if (!cart.items || cart.items.length === 0) {
      itemsWrap.innerHTML = '';
      emptyWrap.classList.remove('hidden');
      footer.classList.remove('hidden');

      if (checkoutBtn) {
        checkoutBtn.classList.add('is-disabled');
        checkoutBtn.setAttribute('aria-disabled', 'true');
        checkoutBtn.setAttribute('tabindex', '-1');
      }

      return;
    }

    emptyWrap.classList.add('hidden');
    footer.classList.remove('hidden');

    if (checkoutBtn) {
      checkoutBtn.classList.remove('is-disabled');
      checkoutBtn.removeAttribute('aria-disabled');
      checkoutBtn.removeAttribute('tabindex');
    }

    itemsWrap.innerHTML = cart.items.map((item) => {
      const image = item.image ? `${item.image}&width=320` : '';
      const variantText = getVariantText(item);
      const displayTitle = getDisplayTitle(item.handle, item.product_title);

      return `
        <div class="beovea-cart-item" data-line-item-key="${item.key}">
          <a href="${item.url}" class="beovea-cart-item__image">
            ${image ? `<img src="${image}" alt="${displayTitle}">` : ''}
          </a>

          <div class="beovea-cart-item__main">
            <div class="beovea-cart-item__main-top">
              <a href="${item.url}" class="beovea-cart-item__title">${displayTitle}</a>
              ${variantText ? `<div class="beovea-cart-item__variant">${variantText}</div>` : `<div class="beovea-cart-item__variant"></div>`}
            </div>

            <div class="beovea-cart-item__qty-wrap">
              <button type="button" class="beovea-cart-item__qty-btn" aria-label="Decrease quantity" data-cart-qty-change data-line-key="${item.key}" data-new-qty="${Math.max(item.quantity - 1, 0)}">−</button>
              <span class="beovea-cart-item__qty-num">${item.quantity}</span>
              <button type="button" class="beovea-cart-item__qty-btn" aria-label="Increase quantity" data-cart-qty-change data-line-key="${item.key}" data-new-qty="${item.quantity + 1}">+</button>
            </div>
          </div>

          <div class="beovea-cart-item__side">
            <div class="beovea-cart-item__price">${formatMoney(item.final_line_price)}</div>
            <button type="button" class="beovea-cart-item__remove" aria-label="Remove item" data-cart-remove data-line-key="${item.key}">×</button>
          </div>
        </div>
      `;
    }).join('');
  }

  async function refreshCart(openAfterRefresh = false) {
    try {
      const cart = await getCart();
      renderItems(cart);
      renderRandomRecommendations(cart);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));

      if (openAfterRefresh) {
        openDrawer();
      }
    } catch (error) {
      console.error('Cart refresh failed:', error);
    }
  }

  async function changeItemQuantity(lineKey, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });

      await refreshCart(false);
    } catch (error) {
      console.error('Cart update failed:', error);
    }
  }

  async function addRecommendationToCart(variantId) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      await refreshCart(true);
    } catch (error) {
      console.error('Recommendation add failed:', error);
      alert('Sorry, failed to add to cart.');
    }
  }

  renderRandomRecommendations();

  openBtns.forEach((btn) => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      await refreshCart(true);
    });
  });

  closeBtn?.addEventListener('click', closeDrawer);

  overlay.addEventListener('click', function (e) {
    e.preventDefault();
    closeDrawer();
  });

  document.addEventListener('pointerdown', function (e) {
    if (!drawer.classList.contains('active')) return;
    if (e.target.closest('[data-beovea-cart-drawer]')) return;
    closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('click', function (e) {
    const disabledCheckout = e.target.closest('.beovea-cart-drawer__checkout.is-disabled');
    if (disabledCheckout) {
      e.preventDefault();
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-qty-change]');
    const removeBtn = e.target.closest('[data-cart-remove]');
    const recAddBtn = e.target.closest('[data-cart-rec-add]');

    if (qtyBtn) {
      const key = qtyBtn.dataset.lineKey;
      const newQty = parseInt(qtyBtn.dataset.newQty || '1', 10);
      changeItemQuantity(key, newQty);
      return;
    }

    if (removeBtn) {
      const key = removeBtn.dataset.lineKey;
      changeItemQuantity(key, 0);
      return;
    }

    if (recAddBtn) {
      const variantId = recAddBtn.dataset.recVariantId;
      if (variantId) {
        addRecommendationToCart(variantId);
      }
    }
  });

  document.addEventListener('cart:refresh-request', function () {
    refreshCart(false);
  });
});